{
  "tabs": {
    "chat": "ಚಾಟ್",
    "reminders": "ಸ್ಮರಣೆಗಳು",
    "calendar": "ಕ್ಯಾಲೆಂಡರ್",
    "settings": "ಸೆಟ್ಟಿಂಗ್‌ಗಳು"
  },
  "common": {
    "cancel": "ರದ್ದುಮಾಡಿ",
    "save": "ಉಳಿಸಿ",
    "confirm": "ನಿಶ್ಚಿತಪಡಿಸಿ",
    "delete": "ಅಳಿಸಿ",
    "back": "ಹಿಂದೆ",
    "close": "ಮುಚ್ಚಿ",
    "edit": "ತಿದ್ದುಪಡಿ",
    "search": "ಹುಡುಕು",
    "all": "ಎಲ್ಲಾ",
    "loading": "ಲೋಡ್ ಆಗುತ್ತಿದೆ...",
    "error": "ಏನೋ ತಪ್ಪಾಗಿದೆ",
    "notFound": "ಕಾಣಲಿಲ್ಲ",
    "tryAgain": "ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
    "retry": "ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
    "undo": "ಮರುಸ್ಥಾಪನೆ",
    "pullToRefresh": "ನವೀಕರಿಸಲು ಎಳೆ",
    "justNow": "ಇತ್ತೀಚೆಗೆ"
  },
  "auth": {
    "welcome": "FishMemory ಗೆ ಸ್ವಾಗತ",
    "tagline": "ನಿಮ್ಮ WhatsApp ಸ್ಮರಣೆ ಸಹಾಯಕ, ಈಗ ನಿಮ್ಮ ಜೇಬಿನಲ್ಲಿ.",
    "subtitle": "ನಿಮ್ಮ WhatsApp ಸ್ಮರಣೆ ಸಹಾಯಕ, ಈಗ ನಿಮ್ಮ ಜೇಬಿನಲ್ಲಿ.",
    "phoneLabel": "ನಿಮ್ಮ WhatsApp ಸಂಖ್ಯೆ",
    "phoneHint": "ನಾವು WhatsApp ಮೂಲಕ ಪರಿಶೀಲನಾ ಕೋಡ್ ಕಳುಹಿಸುತ್ತೇವೆ",
    "invalidPhone": "ದಯವಿಟ್ಟು ಮಾನ್ಯವಾದ ಫೋನ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
    "continue": "ಮುಂದುವರಿಸಿ",
    "enterPhone": "ನಿಮ್ಮ WhatsApp ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
    "phonePlaceholder": "ಫೋನ್ ಸಂಖ್ಯೆ",
    "sendCode": "ಕೋಡ್ ಕಳುಹಿಸಿ",
    "verifyTitle": "ನಿಮ್ಮ ಸಂಖ್ಯೆಯನ್ನು ಪರಿಶೀಲಿಸಿ",
    "otpSentTo": "6 ಅಂಕಿಗಳ ಕೋಡ್ {{phone}} ಗೆ WhatsApp ಮೂಲಕ ಕಳುಹಿಸಲಾಗಿದೆ",
    "enterFullCode": "ದಯವಿಟ್ಟು ಎಲ್ಲಾ 6 ಅಂಕಿಗಳನ್ನು ನಮೂದಿಸಿ",
    "invalidOtp": "ಅಮಾನ್ಯ ಕೋಡ್. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "otpFailed": "ಕೋಡ್ ಕಳುಹಿಸಲು ವಿಫಲವಾಗಿದೆ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "otpResent": "ಕೋಡ್ ಮರುಕಳುಹಿಸಲಾಗಿದೆ",
    "resendIn": "{{seconds}} ಸೆಕೆಂಡುಗಳಲ್ಲಿ ಮರುಕಳುಹಿಸಿ",
    "resendCode": "ಕೋಡ್ ಮರುಕಳುಹಿಸಿ",
    "enterOtp": "ನಿಮ್ಮ WhatsApp ಗೆ ಕಳುಹಿಸಿದ ಕೋಡ್ ನಮೂದಿಸಿ",
    "verify": "ಪರಿಶೀಲಿಸಿ",
    "resend": "ಕೋಡ್ ಮರುಕಳುಹಿಸಿ",
    "wrongNumber": "ತಪ್ಪು ಸಂಖ್ಯೆ?",
    "backToPhone": "ಫೋನ್ ಗೆ ಹಿಂದಿರುಗಿ",
    "editPhone": "ಫೋನ್ ಸಂಖ್ಯೆಯನ್ನು ಸಂಪಾದಿಸಿ",
    "error": "ದೋಷ",
    "setupTitle": "ನಿಮ್ಮ ವ್ಯವಸ್ಥೆಯನ್ನು ಮಾಡೋಣ",
    "setupSubtitle": "ನೀವು ಯಾವಾಗಲೂ ಇದನ್ನು ಸೆಟ್ಟಿಂಗ್ಸ್ ನಲ್ಲಿ ಬದಲಾಯಿಸಬಹುದು",
    "namePlaceholder": "ನಿಮ್ಮ ಹೆಸರು",
    "letsGo": "ಸೆಟಪ್ ಮುಗಿಸಿ",
    "skipForNow": "ಈಗ ಬಿಟ್ಟುಬಿಡಿ"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "ಸಂದೇಶವನ್ನು ಟೈಪ್ ಮಾಡಿ...",
    "inputPlaceholder": "ಸಂದೇಶವನ್ನು ಟೈಪ್ ಮಾಡಿ...",
    "typing": "FishMemory ಟೈಪ್ ಮಾಡುತ್ತಿದೆ...",
    "online": "ಆನ್‌ಲೈನ್",
    "connecting": "ಸಂಪರ್ಕಿಸುತ್ತಿದೆ...",
    "reconnecting": "ಮತ್ತೆ ಸಂಪರ್ಕಿಸುತ್ತಿದೆ...",
    "offline": "ಆಫ್‌ಲೈನ್",
    "empty": "ಸಂವಾದ ಪ್ರಾರಂಭಿಸಿ",
    "emptyHint": "ಸ್ಮರಣೆಗಳನ್ನು ರಚಿಸಿ, ನಿಮ್ಮ ವೇಳಾಪಟ್ಟಿಯನ್ನು ಪರಿಶೀಲಿಸಿ, ಅಥವಾ ಸಹಾಯ ಕೇಳಿ.",
    "emptyAction": "ಮಾದರಿ ಸ್ಮರಣೆ ಕಳುಹಿಸಿ",
    "actions": "ಚಾಟ್ ಕ್ರಿಯೆಗಳು",
    "keep": "ಸಂದೇಶಗಳನ್ನು ಉಳಿಸಿ",
    "clearTitle": "ಚಾಟ್ ತೆರವುಗೊಳಿಸಿ",
    "clearConfirm": "ಈ ಸಾಧನದಿಂದ ಎಲ್ಲಾ ಸಂದೇಶಗಳನ್ನು ಅಳಿಸಲು ಇಚ್ಛಿಸುತ್ತೀರಾ? ಇದನ್ನು ಮರಳಿ ಮಾಡಲಾಗುವುದಿಲ್ಲ.",
    "clear": "ಚಾಟ್ ತೆರವುಗೊಳಿಸಿ",
    "optionSelected": "ಆಯ್ಕೆ ಮಾಡಲಾಗಿದೆ: {{label}}",
    "sendingSelection": "ಕಳುಹಿಸಲಾಗುತ್ತಿದೆ...",
    "connectionLost": "ಮತ್ತೆ ಸಂಪರ್ಕಿಸುತ್ತಿದೆ..."
  },
  "reminders": {
    "title": "ನನ್ನ ಸ್ಮರಣೆಗಳು",
    "active": "ಸಕ್ರಿಯ",
    "today": "ಇಂದು",
    "thisWeek": "ಈ ವಾರ",
    "history": "ಇತಿಹಾಸ",
    "items": "ಐಟಂಗಳು",
    "emptyTitle": "ಇನ್ನೂ ಸ್ಮರಣೆಗಳಿಲ್ಲ",
    "emptySubtitle": "ಚಾಟ್ ನಿಂದ ಒಂದು ರಚಿಸಿ, ಅದು ಇಲ್ಲಿ ತೋರಿಸಲಾಗುತ್ತದೆ.",
    "emptyAction": "ಚಾಟ್ ತೆರೆಯಿರಿ",
    "filterActive": "ಸಕ್ರಿಯ",
    "filterToday": "ಇಂದು",
    "filterWeek": "ಈ ವಾರ",
    "filterHistory": "ಇತಿಹಾಸ",
    "emptyState": "ಇನ್ನೂ ಸ್ಮರಣೆಗಳಿಲ್ಲ. ಚಾಟ್ ಪ್ರಾರಂಭಿಸಿ!",
    "swipeDone": "ಮುಗಿದಿದೆ",
    "swipeSnooze": "ಸ್ನೂಜ್ ಮಾಡಿ",
    "swipeDelete": "ಅಳಿಸಿ",
    "search": "ಸ್ಮರಣೆಗಳನ್ನು ಹುಡುಕಿ...",
    "upcoming": "ಬರುವವು",
    "completed": "ಮುಗಿದವು",
    "overdue": "ವಿಳಂಬವಾಗಿದೆ",
    "tomorrow": "ನಾಳೆ",
    "synced": "{{value}} ಸಿಂಕ್ ಮಾಡಲಾಗಿದೆ",
    "swipeHint": "ಹೆಚ್ಚಿನ ಕ್ರಿಯೆಗಳಿಗೆ ಸ್ಮರಣೆಯನ್ನು ಸ್ವೈಪ್ ಮಾಡಿ",
    "noResults": "ನಿಮ್ಮ ಹುಡುಕಾಟಕ್ಕೆ ಹೊಂದಿಕೆಯಾಗುವ ಸ್ಮರಣೆಗಳಿಲ್ಲ",
    "noResultsHint": "ಬೇರೆಯ ಪದವನ್ನು ಪ್ರಯತ್ನಿಸಿ ಅಥವಾ ಹುಡುಕಾಟವನ್ನು ತೆರವುಗೊಳಿಸಿ",
    "deleteAllFailed": "ಎಲ್ಲಾ ಸ್ಮರಣೆಗಳನ್ನು ಅಳಿಸಲು ವಿಫಲವಾಗಿದೆ"
  },
  "calendar": {
    "title": "ಕ್ಯಾಲೆಂಡರ್",
    "today": "ಇಂದು",
    "tomorrow": "ನಾಳೆ",
    "completed": "ಮುಗಿದಿದೆ",
    "noEvents": "ಯಾವುದೂ ಯೋಜನೆ ಇಲ್ಲ",
    "noEventsSubtitle": "ಸ್ಮರಣೆಗಳು ಮತ್ತು ಕ್ಯಾಲೆಂಡರ್ ಘಟನೆಗಳನ್ನು ನೋಡಲು ದಿನಾಂಕವನ್ನು ಆಯ್ಕೆಮಾಡಿ.",
    "googleEvent": "Google ಕ್ಯಾಲೆಂಡರ್",
    "legendActive": "ಸಕ್ರಿಯ",
    "legendRecurring": "ಮರುಕಳಿಸುವ",
    "legendDone": "ಮುಗಿದಿದೆ",
    "legendGoogle": "Google",
    "previousMonth": "ಹಿಂದಿನ ತಿಂಗಳು",
    "nextMonth": "ಮುಂದಿನ ತಿಂಗಳು",
    "previousYear": "ಹಿಂದಿನ ವರ್ಷ",
    "nextYear": "ಮುಂದಿನ ವರ್ಷ",
    "goToToday": "ಇಂದಿಗೆ ಹೋಗಿ",
    "all": "ಎಲ್ಲಾ",
    "active": "ಸಕ್ರಿಯ",
    "done": "ಮುಗಿದಿದೆ",
    "paused": "ಸ್ಥಗಿತ"
  },
  "settings": {
    "title": "ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
    "profile": "ಪ್ರೊಫೈಲ್",
    "name": "ಪ್ರದರ್ಶನ ಹೆಸರು",
    "enterName": "ನಿಮ್ಮ ಹೆಸರು ನಮೂದಿಸಿ",
    "language": "ಭಾಷೆ",
    "uiLanguage": "ಆಪ್ ಭಾಷೆ",
    "uiLanguageHelp": "ಈ ಸಾಧನದಲ್ಲಿ ಮಾತ್ರ ಆಪ್ UI, ಕ್ಯಾಲೆಂಡರ್ ಲೇಬಲ್ಗಳು ಮತ್ತು ವಿನ್ಯಾಸ ದಿಕ್ಕನ್ನು ಬದಲಾಯಿಸುತ್ತದೆ.",
    "serverLanguage": "ಚಾಟ್ ಭಾಷೆ",
    "serverLanguageHelp": "ನಿಮ್ಮ ಖಾತೆಗೆ ಸರ್ವರ್ ಪ್ರತಿಕ್ರಿಯೆಗಳು ಮತ್ತು ಸ್ಮರಣೆ ಸಂದೇಶಗಳಿಗೆ ಬಳಸುವ ಭಾಷೆಯನ್ನು ಬದಲಾಯಿಸುತ್ತದೆ.",
    "timezone": "ಸಮಯ ವಲಯ",
    "currentTimezone": "ಪ್ರಸ್ತುತ ಸಮಯ ವಲಯ",
    "timezoneHelp": "ಎಲ್ಲಾ ಸ್ಮರಣೆ ಸಮಯಗಳು ಈ ಸಮಯ ವಲಯವನ್ನು ಬಳಸಿಕೊಂಡು ತೋರಿಸಲಾಗುತ್ತದೆ.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "ಸಮಯ ವಲಯ ಉಳಿಸಿ",
    "timezoneSaved": "ಸಮಯ ವಲಯ ನವೀಕರಿಸಲಾಗಿದೆ",
    "detect": "ಹುಡುಕಿ",
    "detectFailed": "ಸಮಯ ವಲಯವನ್ನು ಕಂಡುಹಿಡಿಯಲಾಗಲಿಲ್ಲ",
    "autoDetect": "GPS ನಿಂದ ಸ್ವಯಂಚಾಲಿತ ಪತ್ತೆ",
    "notifications": "ಅಧಿಸೂಚನೆಗಳು",
    "notificationsHelp": "ಫಾಲೋ-ಅಪ್ ಸ್ಮರಣೆಗಳು ಸ್ಮರಣೆ ನೀಡಿದ ನಂತರ ಪುನರಾವೃತ್ತಿ ಎಚ್ಚರಿಕೆಗಳನ್ನು ನಿಯಂತ್ರಿಸುತ್ತವೆ. ಸಾಧನ ಮಟ್ಟದ ಅಧಿಸೂಚನೆ ಅನುಮತಿಗಳನ್ನು ನಿಮ್ಮ ಫೋನ್ ಸೆಟ್ಟಿಂಗ್‌ಗಳಲ್ಲಿ ನಿರ್ವಹಿಸಲಾಗುತ್ತದೆ.",
    "pushEnabled": "ಪುಷ್ ಅಧಿಸೂಚನೆಗಳು",
    "autoDoneOnFire": "ಫೈರ್ ಆಗುವಾಗ ಸ್ವಯಂಚಾಲಿತವಾಗಿ ಮುಗಿಸಿದಂತೆ ಗುರುತಿಸಿ",
    "autoDoneOnFireDesc": "ಆಫ್ ಆಗಿದ್ದರೆ, ನೀವು ಮುಗಿಸಿದಂತೆ ಗುರುತಿಸುವವರೆಗೆ ಸ್ಮರಣೆಗಳು ಸಕ್ರಿಯವಾಗಿರುತ್ತವೆ.",
    "googleCalendar": "Google ಕ್ಯಾಲೆಂಡರ್",
    "google": "Google ಕ್ಯಾಲೆಂಡರ್",
    "googleConnected": "ಸಂಪರ್ಕಿಸಲಾಗಿದೆ",
    "googleDisconnected": "ಸಂಪರ್ಕಿಸಲಾಗಿಲ್ಲ",
    "googleConnectedHelp": "ಹೊಸ ಸ್ಮರಣೆಗಳನ್ನು ನಿಮ್ಮ ಕ್ಯಾಲೆಂಡರ್‌ಗೆ ಸ್ವಯಂಚಾಲಿತವಾಗಿ ಸಿಂಕ್ ಮಾಡಬಹುದು.",
    "googleDisconnectedHelp": "ಸ್ಮರಣೆಗಳು ಮತ್ತು ಘಟನೆಗಳನ್ನು ಹೊಂದಿಸಲು Google ಕ್ಯಾಲೆಂಡರ್ ಅನ್ನು ಸಂಪರ್ಕಿಸಿ.",
    "googleConnectFailed": "Google ಕ್ಯಾಲೆಂಡರ್ ಸಂಪರ್ಕಿಸಲು ವಿಫಲವಾಗಿದೆ",
    "connected": "ಸಂಪರ್ಕಿಸಲಾಗಿದೆ",
    "disconnected": "ಸಂಪರ್ಕಿಸಲಾಗಿಲ್ಲ",
    "connect": "ಸಂಪರ್ಕಿಸಿ",
    "disconnect": "ಕಡಿತಮಾಡಿ",
    "autoSync": "ಹೊಸ ಸ್ಮರಣೆಗಳನ್ನು ಸ್ವಯಂಚಾಲಿತ ಸಿಂಕ್ ಮಾಡಿ",
    "autosync": "ಹೊಸ ಸ್ಮರಣೆಗಳನ್ನು ಸ್ವಯಂಚಾಲಿತ ಸಿಂಕ್ ಮಾಡಿ",
    "subscription": "ಚಂದಾದಾರಿಕೆ",
    "trialUsed": "ಪ್ರಯೋಗ: {{used}}/{{total}} ಬಳಕೆ ಮಾಡಲಾಗಿದೆ",
    "trialStatus": "ಪ್ರಯೋಗ ಲಭ್ಯವಿದೆ",
    "activeStatus": "ಸಕ್ರಿಯ ಚಂದಾದಾರಿಕೆ",
    "expiredStatus": "ಚಂದಾದಾರಿಕೆ ಅವಧಿ ಮುಗಿದಿದೆ",
    "unsubscribedStatus": "ಚಂದಾದಾರಿಕೆಯಾಗಿಲ್ಲ",
    "about": "ಬಗ್ಗೆ",
    "version": "ಆವೃತ್ತಿ",
    "logout": "ಲಾಗ್ ಔಟ್",
    "logoutTitle": "ಲಾಗ್ ಔಟ್",
    "logoutConfirm": "ನೀವು ಖಚಿತವಾಗಿ ಲಾಗ್ ಔಟ್ ಆಗಲು ಬಯಸುತ್ತೀರಾ?",
    "noName": "ಹೆಸರು ಹೊಂದಿಸಲಾಗಿಲ್ಲ",
    "serverConnection": "ಸರ್ವರ್ ಸಂಪರ್ಕ",
    "serverUrl": "ಸರ್ವರ್ URL",
    "serverEdit": "ತಿದ್ದುಪಡಿ",
    "saveReconnect": "ಉಳಿಸಿ ಮತ್ತು ಮತ್ತೆ ಸಂಪರ್ಕಿಸಿ",
    "resetDefault": "ಡೀಫಾಲ್ಟ್‌ಗೆ ಮರುಹೊಂದಿಸಿ",
    "invalidServerUrlTitle": "ಅಮಾನ್ಯ ಸರ್ವರ್ URL",
    "invalidServerUrlMessage": "ದಯವಿಟ್ಟು ಮಾನ್ಯ http ಅಥವಾ https ಸರ್ವರ್ URL ನಮೂದಿಸಿ, ಉದಾಹರಣೆಗೆ https://example.com",
    "uiLanguageChangeFailed": "ಆಪ್ ಭಾಷೆಯನ್ನು ಬದಲಾಯಿಸಲು ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "serverLanguageChangeFailed": "ಚಾಟ್ ಭಾಷೆಯನ್ನು ಬದಲಾಯಿಸಲು ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "timezoneChangeFailed": "ಸಮಯ ವಲಯವನ್ನು ಬದಲಾಯಿಸಲು ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "autoSyncChangeFailed": "ಸ್ವಯಂಚಾಲಿತ ಸಿಂಕ್ ನವೀಕರಣ ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "nameChangeFailed": "ಪ್ರದರ್ಶನ ಹೆಸರನ್ನು ನವೀಕರಿಸಲು ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "ಸ್ಮರಣೆ ವಿವರಗಳು",
    "editTime": "ಸಮಯ ತಿದ್ದುಪಡಿ",
    "rename": "ಪುನಃ ಹೆಸರು ನಿಗದಿ ಮಾಡಿ",
    "snooze": "ಸ್ನೂಜ್ ಮಾಡಿ",
    "snooze15": "15 ನಿಮಿಷ ಸ್ನೂಜ್ ಮಾಡಿ",
    "pause": "ಸ್ಥಗಿತ ಮಾಡಿ",
    "pauseReminder": "ಸ್ಮರಣೆಯನ್ನು ಸ್ಥಗಿತ ಮಾಡಿ",
    "resume": "ಮರುಪ್ರಾರಂಭಿಸಿ",
    "resumeReminder": "ಸ್ಮರಣೆಯನ್ನು ಮರುಪ್ರಾರಂಭಿಸಿ",
    "skip": "ಮುಂದಿನದು ಬಿಟ್ಟುಬಿಡಿ",
    "skipOccurrence": "ಈ ಸಂಭವನೆಯನ್ನು ಬಿಟ್ಟುಬಿಡಿ",
    "syncGoogle": "Google ಗೆ ಸಿಂಕ್ ಮಾಡಿ",
    "delete": "ಅಳಿಸಿ",
    "deleteTitle": "ಸ್ಮರಣೆ ಅಳಿಸಿ",
    "deleteConfirm": "ಈ ಸ್ಮರಣೆ ಶಾಶ್ವತವಾಗಿ ಅಳಿಸಲಾಗುತ್ತದೆ.",
    "deleteRecurringTitle": "ಮರುಕಳಿಸುವ ಸ್ಮರಣೆ ಅಳಿಸಿ",
    "deleteRecurringMessage": "ನೀವು ಈ ಸಂಭವನೆಯನ್ನು ಬಿಟ್ಟುಬಿಡಲು ಅಥವಾ ಸಂಪೂರ್ಣ ಸರಣಿಯನ್ನು ಅಳಿಸಲು ಬಯಸುತ್ತೀರಾ?",
    "deleteThisOccurrence": "ಈ ಸಂಭವನೆಯನ್ನು ಬಿಟ್ಟುಬಿಡಿ",
    "deleteEntireSeries": "ಸಂಪೂರ್ಣ ಸರಣಿಯನ್ನು ಅಳಿಸಿ",
    "done": "ಮುಗಿದಿದೆ",
    "markDone": "ಮುಗಿದಂತೆ ಗುರುತಿಸಿ",
    "undo": "ಮರುಸ್ಥಾಪಿಸಿ",
    "undoPrompt": "ಮತ್ತೆ ಸಕ್ರಿಯವಾಗಬೇಕೇ? ಈಗ ಮರುಸ್ಥಾಪಿಸಿ.",
    "recurring": "ಮರುಕಳಿಸುವ",
    "nextRun": "ಮುಂದಿನ ಚಾಲನೆ",
    "oneTime": "ಒಮ್ಮೆ ಮಾತ್ರ",
    "pending": "ಬಾಕಿ ಇದೆ",
    "sent": "ಕಳುಹಿಸಲಾಗಿದೆ",
    "paused": "ಸ್ಥಗಿತವಾಗಿದೆ",
    "active": "ಸಕ್ರಿಯ",
    "snoozed": "ಸ್ನೂಜ್ ಮಾಡಲಾಗಿದೆ",
    "localTime": "ನಿಮ್ಮ ಸ್ಥಳೀಯ ಸಮಯದಲ್ಲಿ ತೋರಿಸಲಾಗಿದೆ",
    "recurrence": "ಮರುಕಳಿಸುವಿಕೆ",
    "created": "ರಚಿಸಲಾಗಿದೆ",
    "tags": "ಟ್ಯಾಗ್‌ಗಳು",
    "fireCount": "ಬಾರಿಯಷ್ಟು ಫೈರ್ ಆಗಿದೆ",
    "actions": "ಕ್ರಿಯೆಗಳು",
    "none": "ಯಾವುದೂ ಇಲ್ಲ",
    "snoozeFailed": "ಸ್ಮರಣೆಯನ್ನು ಸ್ನೂಜ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ",
    "pauseFailed": "ಸ್ಮರಣೆಯನ್ನು ಸ್ಥಗಿತ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ",
    "resumeFailed": "ಸ್ಮರಣೆಯನ್ನು ಮರುಪ್ರಾರಂಭಿಸಲು ವಿಫಲವಾಗಿದೆ",
    "skipFailed": "ಸ್ಮರಣೆಯನ್ನು ಬಿಟ್ಟುಬಿಡಲು ವಿಫಲವಾಗಿದೆ",
    "doneFailed": "ಸ್ಮರಣೆಯನ್ನು ಮುಗಿದಂತೆ ಗುರುತಿಸಲು ವಿಫಲವಾಗಿದೆ",
    "undoFailed": "ಸ್ಮರಣೆ ಸ್ಥಿತಿಯನ್ನು ಮರುಸ್ಥಾಪಿಸಲು ವಿಫಲವಾಗಿದೆ",
    "deleteFailed": "ಸ್ಮರಣೆಯನ್ನು ಅಳಿಸಲು ವಿಫಲವಾಗಿದೆ",
    "rescheduleTitle": "ಮರುನಿಯೋಜನೆ ಮಾಡಬೇಕೇ?",
    "rescheduleMsg": "ಈ ಸ್ಮರಣೆ ವಿಳಂಬವಾಗಿದೆ. ನೀವು ಇದನ್ನು ಮರುನಿಯೋಜನೆ ಮಾಡಬೇಕೆಂದು ಬಯಸುತ್ತೀರಾ?",
    "reschedule15": "15 ನಿಮಿಷಗಳಲ್ಲಿ",
    "reschedule60": "1 ಗಂಟೆಯಲ್ಲಿ",
    "keepOverdue": "ಹೀಗೆಯೇ ಇಡಿ"
  },
  "onboarding": {
    "slide1Title": "FishMemory ಗೆ ಸ್ವಾಗತ",
    "slide1Sub": "ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಸ್ಮರಣೆ ಸಹಾಯಕ — WhatsApp ಮೂಲಕ ಚಾಲಿತ ಮತ್ತು ನಿಮ್ಮ ಜೇಬಿಗಾಗಿ ನಿರ್ಮಿತ.",
    "slide2Title": "ಸ್ವಾಭಾವಿಕವಾಗಿ ಚಾಟ್ ಮಾಡಿ",
    "slide2Sub": "\"ನಾಳೆ 3 ಗಂಟೆಗೆ ಅಮ್ಮನಿಗೆ ಕರೆ ಮಾಡಲು ನೆನಪಿಸು\" ಎಂದು ಟೈಪ್ ಮಾಡಿ — ಉಳಿದದ್ದು ನಾವು ನೋಡಿಕೊಳ್ಳುತ್ತೇವೆ.",
    "slide3Title": "ಏನನ್ನೂ ತಪ್ಪಿಸಿಕೊಳ್ಳಬೇಡಿ",
    "slide3Sub": "ಸಮಯೋಚಿತ ಅಧಿಸೂಚನೆಗಳನ್ನು ಪಡೆಯಿರಿ, ಟ್ಯಾಗ್‌ಗಳೊಂದಿಗೆ ಸಂಘಟಿಸಿ, ಮತ್ತು ಮಹತ್ವದ ಎಲ್ಲದರ ಮೇಲೆಯೂ ಗಮನವಿರಿಸಿ.",
    "getStarted": "ಪ್ರಾರಂಭಿಸಿ",
    "next": "ಮುಂದೆ",
    "firstReminderTitle": "ನಿಮ್ಮ ಮೊದಲ ಸ್ಮರಣೆಯನ್ನು ರಚಿಸಿ!",
    "firstReminderHint": "ಹೀಗೆ ಟೈಪ್ ಮಾಡಿ ಪ್ರಯತ್ನಿಸಿ:",
    "firstReminderExample": "ನಾಳೆ ಬೆಳಗ್ಗೆ 9 ಗಂಟೆಗೆ ನೀರು ಕುಡಿಯಲು ನೆನಪಿಸು",
    "gotIt": "ಬರೀ ತಿಳಿದುಕೊಂಡೆ!",
    "notifRationaleTitle": "ಸಮಯಕ್ಕೆ ಇರಿ",
    "notifRationaleBody": "FishMemory ನಿಮಗೆ ಸಮಯಕ್ಕೆ ಸ್ಮರಣೆ ನೀಡಲು ಅಧಿಸೂಚನೆಗಳನ್ನು ಅಗತ್ಯವಿದೆ. ನೀವು ರಚಿಸಿದ ಸ್ಮರಣೆಗಳಿಗೆ ಮಾತ್ರ ಎಚ್ಚರಿಕೆಗಳು ಬರುತ್ತವೆ.",
    "notifRationaleAllow": "ಅಧಿಸೂಚನೆಗಳನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಿ",
    "notifRationaleLater": "ಬಾದ್ದು ನಂತರ",
    "swipeHint": "ತ್ವರಿತ ಕ್ರಿಯೆಗಳಿಗೆ ಬಲಕ್ಕೆ ಸ್ವೈಪ್ ಮಾಡಿ →",
    "calendarDragHint": "ವಿಸ್ತರಿಸಲು ಎಳೆ ↕"
  }
}
